import { __assign } from "tslib";
import React, { useMemo } from 'react';
import { Tooltip as BaseTooltip, Text } from '@keen.io/ui-core';
import { formatValue as valueFormatter, } from '@keen.io/charts-utils';
import { PartialsContainer, Value, TotalContainer, PartialItem, } from './tooltip.styles';
import { calculatePartialPercents } from './utils';
export var Tooltip = function (_a) {
    var geographicalName = _a.geographicalName, totalValue = _a.totalValue, theme = _a.theme, partialValues = _a.partialValues, formatValue = _a.formatValue, _b = _a.mode, mode = _b === void 0 ? 'dark' : _b;
    var partialElements = useMemo(function () {
        if (partialValues) {
            return calculatePartialPercents(totalValue, partialValues);
        }
        return null;
    }, [geographicalName, totalValue, partialValues]);
    return (React.createElement(BaseTooltip, { mode: mode, hasArrow: false, hasSpacing: false },
        React.createElement(TotalContainer, null,
            React.createElement(Text, __assign({ htmlElement: "span" }, theme.labels.typography),
                geographicalName,
                React.createElement("span", null, ":")),
            ' ',
            React.createElement(Value, null,
                React.createElement(Text, __assign({}, theme.values.typography), valueFormatter(totalValue, formatValue)))),
        partialElements && (React.createElement(PartialsContainer, { mode: mode }, partialElements.map(function (_a) {
            var label = _a.label, value = _a.value, percentValue = _a.percentValue;
            return (React.createElement(PartialItem, { key: label + "-" + value },
                React.createElement(Text, __assign({}, theme.labels.typography),
                    label,
                    React.createElement("span", null, ":")),
                React.createElement(Value, null,
                    React.createElement(Text, __assign({ htmlElement: "span" }, theme.labels.typography),
                        "(",
                        percentValue,
                        ")"),
                    ' ',
                    React.createElement(Text, __assign({ htmlElement: "span" }, theme.values.typography), valueFormatter(value, formatValue)))));
        })))));
};
export default Tooltip;
